// ใครเข้าถึงแบรนด์นี้ได้บ้าง — ตั้งในหน้า config ของแบรนด์
//
// มีผลกับคนที่ถือ role "Agency Intelligence User" เท่านั้น · Admin เห็นทุกแบรนด์อยู่แล้ว
// จึงบอกไว้ตรง ๆ ในหน้า ไม่งั้นแอดมินจะงงว่าทำไมใส่ชื่อแล้วตัวเองยังเห็นเหมือนเดิม
//
// ตัวรายชื่อกับปุ่มแก้อยู่ใน MemberRoster ซึ่งใช้ร่วมกับหน้า Team ของแบรนด์
import { useAppSelector } from "@/app/hooks";
import { MemberRoster } from "./member-roster";

export function BrandMembersSection({ brandId, enabled }: { brandId: string; enabled: boolean }) {
  const session = useAppSelector((s) => s.session.current);

  if (!enabled)
    return <p className="muted">เปิดสวิตช์ My Job ด้านบนก่อน จึงจะกำหนดผู้เข้าถึงแบรนด์นี้ได้</p>;

  return (
    <>
      <p className="muted small-note">
        รายชื่อนี้มีผลกับผู้ใช้ที่ได้สิทธิ์ <b>Agency Intelligence User</b> เท่านั้น —
        คนที่ไม่อยู่ในรายชื่อจะไม่เห็นแบรนด์นี้ใน My Job ส่วน <b>Admin</b> เห็นทุกแบรนด์เสมอ ·{" "}
        <b>ผู้ดูแล (manage)</b> เพิ่มหรือถอดคนอื่นของแบรนด์นี้ได้เองจากเมนู Team ส่วน{" "}
        <b>ผู้ดู (viewer)</b> ดูรายชื่อได้อย่างเดียว
      </p>

      {/* หน้านี้เปิดได้เฉพาะ Admin อยู่แล้ว (RequireAdmin ที่ route) จึงแก้ได้เสมอ */}
      <MemberRoster
        brandId={brandId}
        canManage
        allowSelfEdit
        meCode={session?.empCode}
        enabled={enabled}
      />
    </>
  );
}
